import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import CustomTextField from 'src/components/custom/CustomTextField';
import { PRODUCT_SEGMENTATION_FILTERS } from 'src/utils/constants';

const DualAxisColumn = ({
  chartConfigs,
  height,
  title,
  periodFilter,
  setPeriodFilter,
}) => {

  const [configs, setConfigs] = useState({});

  useEffect(() => {
    const _configs = {
      title: title || '',
      height: height || 350,
      periodFilter: periodFilter || '',
      series: chartConfigs?.series || [],
      options: {
        chart: {
          type: 'column',
          height: height || 350,
          stacked: false,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [1, 1, 4]
        },
        xaxis: {
          categories: chartConfigs?.categories || [""],
        },
        yaxis: chartConfigs?.series?.map(c => c?.yAxis) || [],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          },
        },
        legend: {
          horizontalAlign: 'center',
          offsetX: 40
        }
      },
    };
    setConfigs(_configs);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartConfigs, height, title, periodFilter]);

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack
          direction="row"
          sx={{
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 2
          }}
          spacing={1}
        >
          <Typography variant="h5" > {configs.title || "Order Tracking (m\u00B3)"} </Typography>
          <CustomTextField
            variant="standard"
            sx={{ maxWidth: 150 }}
            select
            labelId="period-select-label"
            value={periodFilter}
            onChange={(e) => { setPeriodFilter(e.target.value) }}
          >
            <MenuItem value="" selected disabled>
              <em>Select Period</em>
            </MenuItem>
            {PRODUCT_SEGMENTATION_FILTERS.map((p) => (
              <MenuItem key={p.key} value={p.key}>
                {p.value}
              </MenuItem>
            ))}
          </CustomTextField>
        </Stack>

        {configs?.series?.length > 0 &&
          <div id="chart">
            <ReactApexChart
              options={configs.options}
              series={configs.series}
              type="line"
              height={configs.height}
            />
          </div>
        }
      </CardContent>
    </Card>
  );

}
export default DualAxisColumn;
